import { LYTICK_ICONS } from "@/lib/constants/icon-paths"
import { SymbolTicker } from "@/components/layout/SymbolTicker"
import { TimeframeSelector } from "@/components/lytick/TimeframeSelector"
import { TemplateSelector } from "@/components/features/TemplateSelector"
import { TooltipProvider } from "@/components/ui/tooltip"
import { IconButtonGroup } from "@/components/design-system"
import { ChartTypeTrigger } from "./ChartTypeTrigger"
import { IndicatorsTrigger } from "./IndicatorsTrigger"
import { ReplayPill } from "./ReplayPill"
import { FullscreenTrigger } from "./FullscreenTrigger"
import { SettingsTrigger } from "./SettingsTrigger"
import { CsvLoadTrigger } from "./CsvLoadTrigger"

/** 1px hairline divider between nav zones — 20px tall, vertically centered */
function ZoneDivider() {
  return (
    <div
      aria-hidden
      style={{
        width: 1,
        height: 20,
        background: "rgba(255,255,255,0.07)",
        flexShrink: 0,
        margin: "0 8px",
      }}
    />
  )
}

/** 1px hairline divider within a zone — shorter, more subtle */
function InnerDivider() {
  return (
    <div
      aria-hidden
      style={{
        width: 1,
        height: 16,
        background: "var(--lyt-border-subtle)",
        flexShrink: 0,
        margin: "0 4px",
      }}
    />
  )
}

export function TopStrip() {
  return (
    <TooltipProvider delayDuration={120}>
      <div
        role="toolbar"
        aria-label="Chart controls"
        style={{
          display: "flex",
          alignItems: "center",
          height: "var(--height-topbar-desktop)",
          paddingLeft: 12,
          paddingRight: 12,
          gap: 0,
          animation: "slideDownFadeIn 200ms ease both",
        }}
      >
        {/* ── Zone A — Brand wordmark ── */}
        <h1 className="sr-only">LYTICK Trading Workspace</h1>
        <button
          type="button"
          onClick={() => document.getElementById("desktop-chart-surface")?.focus()}
          id="lytick-logo-btn"
          aria-label="Lytick — focus chart"
          style={{
            display: "flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "var(--radius-sm)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          <img
            src={LYTICK_ICONS.hero.dark}
            alt="Lytick"
            style={{ height: 18, width: "auto", display: "block" }}
          />
        </button>

        <ZoneDivider />

        {/* ── Zone B — Symbol selector ── */}
        <SymbolTicker />

        <ZoneDivider />

        {/* ── Zone C — Timeframes + chart controls (flex-grow) ── */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            gap: 0,
            minWidth: 0,
          }}
        >
          <TimeframeSelector />

          <InnerDivider />

          <ChartTypeTrigger />
          <TemplateSelector />
          <IndicatorsTrigger />
        </div>

        {/* ── Zone D — Right actions ── */}
        <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
          <ReplayPill />

          <InnerDivider />

          <IconButtonGroup>
            <CsvLoadTrigger />
            <FullscreenTrigger />
            <SettingsTrigger />
          </IconButtonGroup>
        </div>
      </div>
    </TooltipProvider>
  )
}
